var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showToYsh)?_c('div',{on:{"click":_vm.toYsh}},[_c('p',[_vm._v("查看")]),_vm._v(" "),_c('p',[_vm._v("更多视频")])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }